'use strict'


global.renderGoogleButton = () => {


    gapi.load('auth2', function(){
    	const auth2 = gapi.auth2.init({
    		client_id: global.googleSignInKey,
    		cookiepolicy: 'single_host_origin'
    	})
		auth2.attachClickHandler(document.getElementById('g-signin2'), {
			scope: 'profile email'
		}, onSuccess, err => {
			console.error(err)
		})
    })


	/*
	gapi.signin2.render('g-signin2', {
		'scope': 'profile email',
		'width': 300,
		'height': 50,
		'longtitle': true,
		'theme': 'dark',
		'onsuccess': onSuccess
	});
	*/
}

function onSuccess(googleUser){
	const profile = googleUser.getBasicProfile()
	const form = document.querySelector('.googleForm')
	const name = form.querySelector('[name="firstName"]')
	// If registering
	if(name){
		form.querySelector('[name="id"]').value = googleUser.getAuthResponse().id_token
		name.value = profile.getGivenName()
		form.querySelector('[name="lastName"]').value = profile.getFamilyName()
		form.querySelector('[name="email"]').value = profile.getEmail()
	}
	// If logging in
	else{
		form.querySelector('[name="access_token"]').value = googleUser.getAuthResponse().id_token
	}
	googleSignOut(form)
}




// Sign out of Google before submitting form to manage session from the server
function googleSignOut(form){
	gapi.auth2.getAuthInstance().signOut().then(() => {
		form.submit()
	})
}


module.exports = () => {
	
}